// src/components/LandingPage/LandingPage.js
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Header from './components/header';
import Hero from './components/hero';
import Features from './components/features';
import Templates from './components/templates';
import Footer from './components/footer';
import { checkAuthState } from '../../services/utils/auth';

const Wrapper = styled.div`
  background: var(--bg-main);
  color: var(--text-main);
  min-height: 100vh;
  overflow-x: hidden;
  font-family: 'Inter', sans-serif;
  transition: all 0.3s ease;
`;

const LandingPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = checkAuthState(setIsAuthenticated,()=>{});
    return () => unsubscribe(); // Clean up on unmount
  }, []);

  return (
    <Wrapper>
      <Header isAuthenticated={isAuthenticated} />
      <Hero isAuthenticated={isAuthenticated} />
      <Features />
      <Templates />
      <Footer />
    </Wrapper>
  );
};

export default LandingPage;
